import React from "react";
import styled from "styled-components";
import ToggleBtn from "../../../../Button/ToggleBtn";

interface ManagerAuthItemProps {
  title: string;
  desc: string;
  check: boolean;
  checkEvent: () => void;
}

export default function ManagerAuthItem({
  title,
  desc,
  check,
  checkEvent,
}: ManagerAuthItemProps) {
  return (
    <AuthItem>
      <AuthItemColumn>
        <AuthItemDot />

        <div>
          <AuthItemTitle>{title}</AuthItemTitle>

          <AuthItemDesc>{desc}</AuthItemDesc>
        </div>
      </AuthItemColumn>

      <ToggleBtn checkEvent={() => checkEvent()} check={check} />
    </AuthItem>
  );
}

const AuthItem = styled.div`
  width: 100%;
  height: 65px;
  display: flex;
  justify-content: space-between;

  &:not(:last-child) {
    margin-bottom: 20px;
    border-bottom: 1px solid #f5f5f5;
  }
`;

const AuthItemColumn = styled.div`
  display: flex;
  gap: 12px;
`;

const AuthItemDot = styled.div`
  margin-top: 7px;
  width: 4px;
  height: 4px;
  background-color: ${({ theme }) => theme.buttonColor.lineHover};
  border-radius: 50%;
`;

const AuthItemTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: ${({ theme }) => theme.color.gray900};
`;

const AuthItemDesc = styled.p`
  margin-top: 8px;
  font-size: 13px;
  line-height: 19.5px;
  text-align: left;
  color: ${({ theme }) => theme.color.gray500};
`;
